import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdStandingsShareLayoutRoute() {
  return <ModalStack />;
}
